import h from 'virtual-dom/h'

export default class Renderers
{
    constructor(settings)
    {
        this._settings = settings;
    }

    initialize(store, mutators, childRenderers)
    {
        this._mutators = mutators;
        this._childRenderers = childRenderers;
    }

    getRender()
    {
        return () => {
            let parameters = {
                className : this._settings.classNames.headerClassName
            };

            this._mutators.forEach((mutate) => {
                parameters = mutate(parameters);
            });

            let childNodes = [];
            
            this._childRenderers.forEach((render) => {
                childNodes.push(render());
            });

            return h('div', parameters, childNodes);
        };
    }
}



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/window-header/src/renderers/renderers.js